module.exports = __webpack_public_path__ + "img/prop_v1.4572c26.png";